/**
 * Hospital sidebar badge bridge — a minimal Vuex module whose sole purpose
 * is to expose the review queue pending count to Chatwoot's Sidebar component,
 * which wires badges via `getterKeys.count` and resolves them through
 * `useMapGetter()` (which only works on Vuex getters).
 *
 * The Pinia `useHospitalReviewsStore` is the source of truth — this module
 * is kept in sync by a bridge subscription installed in `dashboard.js` (or
 * lazily when the review page mounts), which calls `setPendingCount`.
 *
 * State is intentionally tiny: just the count. All real review data lives in
 * Pinia.
 */

const state = {
  pendingCount: 0,
};

const getters = {
  getPendingCount: $state => $state.pendingCount,
  // Namespaced helper so the sidebar only shows the badge when > 0
  getShowPendingBadge: $state => $state.pendingCount > 0,
};

export const actions = {
  setPendingCount({ commit }, count) {
    commit('SET_HOSPITAL_PENDING_COUNT', Number(count) || 0);
  },
};

export const mutations = {
  SET_HOSPITAL_PENDING_COUNT($state, count) {
    $state.pendingCount = count;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
